import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { ViewEnum } from '@/types';
import { SportMatchModel } from '@nf/types/odds';
import { sportsbookService } from '@/services/sportsbook.service';
import { modalService } from '@/services/modal.service';
import { useAccountStatus } from '@/hooks/query/account';
import { useHasSingleMatchParlay } from '@/hooks/use-has-single-match-parlay';
import { Button } from '@nf/ui';
import { SmpIcon } from '@/components/icons/svg-icons';
import { useCurrentProperties } from '@/hooks/query';
import { AccountActStatus, KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useGoldenDuelSetting } from '@/hooks/query/golden-duel';

interface SmpButtonProps {
	match: SportMatchModel;
	viewType: ViewEnum;
	className: string;
}

export const SmpButton = ({ match, viewType, className }: SmpButtonProps) => {
	const router = useRouter();
	const { eventMode, eventName } = useCurrentProperties();
	const t = useTranslations('General');
	const { data: actStatus } = useAccountStatus();
	const { isGoldenDuelSupported } = useGoldenDuelSetting();

	const hasSMP = useHasSingleMatchParlay({
		sport: match.GameID,
		id34: match.ID34,
		isLive: match.IsLive,
		isIR: match.Tsp,
		betBuilderStatus: match.BBVD,
		showTime: match.ShowTime
	});

	const setPromotionKafka = () => {
		if (isGoldenDuelSupported(match.GameID, match.LeagueId)) {
			setKafkaNormal({
				note: KafkaNote.GoldenDuel,
				type: 1,
				action: 45
			});
		}
	}

	const gotoSmp = (event: React.MouseEvent) => {
		event.stopPropagation();
		setPromotionKafka();

		if (actStatus === AccountActStatus.Deposited) {
			router.push(`${sportsbookService.makeSingleMatchPath({
				gameId: match.GameID,
				maT: match.MaT,
				leagueId: match.LeagueId,
				matchId: match.MatchId,
				eventMode: eventMode,
				eventName: eventName
			})}?cate=SingleMatchParlay`);
		} else {
			modalService.openMessageModal(t('lbl_deposit'));
		}
	};

	return hasSMP ? (
		{
			[ViewEnum.galaxy]: (
				<Button
					data-active={false}
					className={className}
					variant="icon"
					onClick={gotoSmp}
				>
					<SmpIcon />
				</Button>
			),
			[ViewEnum.mars]: (
				<Button
					variant="icon"
					className={className}
					onClick={gotoSmp}
				>
					{t('lbl_SMP')}
				</Button>
			)
		}[viewType]
	) : null;
};